import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';

import { FHButton } from '../../../../../components/base';
import { Themes } from '../../../../../constants';
import { useFormReadOnly } from '../../../../common';
import { TreatmentSection } from './components';
import { useFetchTreatmentPlanV3TreatmentPage, useTreatmentPlanV3Treatment } from './hooks';
import { TREATMENT_CONCLUDE_BUTTON_SX } from './styles';
import { TreatmentPlanV3PageContent } from '../components';

export default function TreatmentForm() {
  const { retry } = useFetchTreatmentPlanV3TreatmentPage();
  const { treatmentPage, treatmentPageLoadCount, isLoading, hasLoadError, isUpdating, updatePage } =
    useTreatmentPlanV3Treatment();
  const readOnly = useFormReadOnly();

  let pageBody;
  if (treatmentPage !== null) {
    pageBody = (
      <TreatmentSection
        key={treatmentPageLoadCount}
        disabled={isLoading || readOnly}
        isUpdating={isUpdating}
        onUpdate={updatePage}
        treatmentPage={treatmentPage}
      />
    );
  } else if (hasLoadError) {
    pageBody = (
      <Stack gap={1} alignItems="flex-start">
        <Typography>Unable to load treatment information. Please try again.</Typography>
        <Button onClick={retry} variant="contained">
          Retry
        </Button>
      </Stack>
    );
  } else {
    pageBody = (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  return (
    <Stack gap={2}>
      <TreatmentPlanV3PageContent title="Treatment recommendations">
        {pageBody}
      </TreatmentPlanV3PageContent>
      <Stack direction="row" justifyContent="flex-end">
        <FHButton colorTheme={Themes.Primary} disabled sx={TREATMENT_CONCLUDE_BUTTON_SX}>
          Conclude
        </FHButton>
      </Stack>
    </Stack>
  );
}
